import React from 'react';
import { Box, Skeleton, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .CSSFooterBox': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    margin: theme.spacing(2, 0),
  },
}));

const ComparisonSectionSkeleton = () => (
  <StyledBox>
    <Container maxWidth="xl">
      <Skeleton variant="text" width="40%" height={40} />
      <Skeleton variant="text" width="70%" height={40} mb={2} />

      <Skeleton variant="rectangular" width="100%" height={350} />

      <Box className="CSSFooterBox">
        <Skeleton variant="rectangular" width={80} height={80} />
        <Skeleton variant="rectangular" width={80} height={80} mx={2} />
        <Skeleton variant="rectangular" width={80} height={80} />
      </Box>
    </Container>
  </StyledBox>
);

export { ComparisonSectionSkeleton };
